import React, { useState, useEffect } from "react";
import { getUserId } from "./utils";
import { FaGem } from "react-icons/fa";
import {
  GiTrophyCup,
  GiEmerald,
  GiGoldBar,
  GiCutDiamond,
  GiIronCross,
} from "react-icons/gi";
import { getDoc, doc } from "firebase/firestore";

const tierCount = {
  Diamond: 10000,
  Platinum: 5000,
  Emerald: 2000,
  Ruby: 500,
  Gold: 100,
  Silver: 35,
  Bronze: 10,
  Iron: 1,
};

export const sortedTiers = Object.entries(tierCount).sort(
  (a, b) => b[1] - a[1]
);

export const tierIcon = {
  Diamond: <FaGem />,
  Platinum: <GiTrophyCup />,
  Emerald: <GiEmerald />,
  Ruby: <GiCutDiamond />,
  Gold: <GiGoldBar />,
  Silver: <GiGoldBar />,
  Bronze: <GiGoldBar />,
  Iron: <GiIronCross />,
};

export const tierColor = {
  Diamond: "#b9f2ff",
  Platinum: "#e5e4e2",
  Emerald: "#50c878",
  Ruby: "#e0115f",
  Gold: "#ffd700",
  Silver: "#c0c0c0",
  Bronze: "#cd7f32",
  Iron: "#434343",
};
const getCurrentTierAndDiff = (count) => {
  for (let i = 0; i < sortedTiers.length; i++) {
    if (count >= sortedTiers[i][1]) {
      return [
        sortedTiers[i][0],
        i > 0 ? sortedTiers[i - 1][1] - count : null,
        i > 0 ? sortedTiers[i - 1][0] : null,
      ];
    }
  }
  return [null, 1, "Iron"];
};

const UserTier = ({ db, refreshTrigger }) => {
  const [tierData, setTierData] = useState(null);

  useEffect(() => {
    const fetchTier = async () => {
      const id = getUserId();
      const idRef = doc(db, "voteCounts", id);
      const docSnap = await getDoc(idRef);

      if (docSnap.exists()) {
        const count = docSnap.data().count;
        const [tier, tierDiff, nextTier] = getCurrentTierAndDiff(count);
        setTierData({ tier, count, tierDiff, nextTier });
      } else {
        setTierData({ tier: "None", count: 0 });
      }
    };

    fetchTier();
  }, [db, refreshTrigger]);

  if (!tierData) return <div></div>;

  return (
    <>
      {tierData.count > 0 ? (
        <div
          className="user-tier-box"
          style={{
            borderColor: tierColor[tierData.tier],
          }}
        >
          <div className="user-tier">
            <span style={{ color: tierColor[tierData.tier] }}>
              {tierIcon[tierData.tier]} {tierData.tier}
            </span>{" "}
            user
          </div>
          {tierData.nextTier && (
            <div className="next-tier">
              {tierData.count} video{tierData.count > 1 ? "s" : ""} rated /{" "}
              {tierData.tierDiff} until {tierData.nextTier}
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default UserTier;
